document.addEventListener("DOMContentLoaded", function () {
    const faqDropdowns = document.querySelectorAll('.faq-checkbox');

    faqDropdowns.forEach(checkbox => {
        checkbox.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.keyCode === 13) {
                checkbox.click();
            }
        });
    });

});